import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { TextAlign, ZIndex } from '@/interface/enum';
import { useCookie } from '@/libraries/composables/useCookie';
import { getImage } from '@/libraries/helpers/imageHelper';
import { i18n } from '@/libraries/i18n';
import { getHost } from '@/libraries/url';
import { useAccountStore } from '@/stores/accountStore';
import { useFeatureToggleStore } from '@/stores/featureToggleStore';
import { useRootStore } from '@/stores/rootStore';

export function useVoucherRedeemPopup() {
    const { isVoucherEnabled } = storeToRefs(useFeatureToggleStore());
    const { isAsi } = storeToRefs(useRootStore());
    const { customerInfo } = storeToRefs(useAccountStore());

    const imageGlob = import.meta.glob('../../../assets/images/voucher-tutorial/*.{png,webp}', {
        eager: true,
    });

    const imageUrl = computed(() => getImage(imageGlob, i18n.locale.value, 'EN'));

    const [viewedUserList, setViewedUserList] = useCookie<string[]>('isViewedVoucherRedeem', [], {
        domain: getHost(),
        expires: 365,
        encode: input => input.join(','),
        decode: input => input.split(',').filter(str => str !== '') ?? [],
    });

    const isTutorialShown = computed(() => {
        if (!customerInfo.value.accountId || customerInfo.value.accountId === '') {
            return true;
        }

        return viewedUserList.value.includes(customerInfo.value.accountId);
    });

    const isShowPopup = computed(() => {
        const query = window.location.search.toLowerCase();
        return isVoucherEnabled.value && query.includes('voucher=1') && !isTutorialShown.value && isAsi.value;
    });

    const popupStyle = {
        zIndex: ZIndex.VoucherRedeemPopup,
        textAlign: TextAlign.Left,
    };

    function closePopup() {
        if (!customerInfo.value.accountId || customerInfo.value.accountId === '') {
            return;
        }

        setViewedUserList([...viewedUserList.value, customerInfo.value.accountId]);
    }

    return {
        isShowPopup,
        closePopup,
        imageUrl,
        popupStyle,
    };
}
